import React from 'react';

const Arrow: React.FC = () => {
  return (
    <svg
      width='47'
      height='8'
      viewBox='0 0 47 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M46.3536 4.35356C46.5488 4.1583 46.5488 3.84171 46.3536 3.64645L43.1716 0.46447C42.9763 0.269208 42.6597 0.269208 42.4645 0.46447C42.2692 0.659732 42.2692 0.976314 42.4645 1.17158L45.2929 4L42.4645 6.82843C42.2692 7.02369 42.2692 7.34028 42.4645 7.53554C42.6597 7.7308 42.9763 7.7308 43.1716 7.53554L46.3536 4.35356ZM0 4L-4.37114e-08 4.5L46 4.5L46 4L46 3.5L4.37114e-08 3.5L0 4Z'
        fill='white'
      />
    </svg>
  );
};

export default Arrow;
